import { space } from '@repo/theme/primitives';

const [DAGRE_EDGE_SEP, DAGRE_NODE_SEP, DAGRE_RANK_SEP] = [
	space[12],
	space[12],
	space[40],
];

export { DAGRE_EDGE_SEP, DAGRE_NODE_SEP, DAGRE_RANK_SEP };
